var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-data-table", {
        staticClass: "mt-2",
        attrs: {
          headers: _vm.headers,
          items: _vm.accessories,
          page: _vm.pagination.page,
          "items-per-page": _vm.paginationAccessoriesAndOthers.rowsPerPage,
          "items-per-page-text": _vm.$t("tables.RowsPerPage"),
          "items-per-page-items": _vm.rowsPerPageItems,
          "header-props": { sortIcon: "mdi-menu-down" },
          "footer-props": {
            prevIcon: "mdi-menu-left",
            nextIcon: "mdi-menu-right",
            "items-per-page-options": _vm.rowsPerPageItems
          }
        },
        on: {
          "update:page": function($event) {
            return _vm.$set(_vm.pagination, "page", $event)
          },
          "update:itemsPerPage": function($event) {
            return _vm.$set(
              _vm.paginationAccessoriesAndOthers,
              "rowsPerPage",
              $event
            )
          },
          "update:items-per-page": function($event) {
            return _vm.$set(
              _vm.paginationAccessoriesAndOthers,
              "rowsPerPage",
              $event
            )
          },
          pagination: function($event) {
            return _vm.setRowsOnLocalStorage(
              _vm.dataTableAccessoriesAndOthersId,
              _vm.paginationAccessoriesAndOthers.rowsPerPage
            )
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(props.item.sm_reference))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.sm_description))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          props.item.sm_quantity
                            ? props.item.sm_quantity
                            : props.item.quantity
                        ) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("app-datatable-action-buttons", {
                        attrs: {
                          "user-can-edit": _vm.disabled
                            ? !_vm.disabled
                            : _vm.canChangeAccessory,
                          "user-can-delete": _vm.disabled
                            ? !_vm.disabled
                            : _vm.canChangeAccessory
                        },
                        on: {
                          edit: function($event) {
                            return _vm.$emit("edit-item", props.index)
                          },
                          delete: function($event) {
                            return _vm.askConfirmationToDeleteItem(props.index)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.deleteDialog,
          title: _vm.titleToDelete,
          content: _vm.$t("DeleteConfirmation") + "?",
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: _vm.cancelDelete,
          secondaryAction: function($event) {
            return _vm.confirmDelete()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6415edd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6415edd4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/AccessoriesAndOthers/AccessoriesAndOthersTable.vue
// module id = null
// module chunks = 